import { MobileAccounts } from '../models';
import { Account, DistributeGroup } from '../shared/forms';
import { MobileDistributeGroups } from './models';

const dashboard = {
    views: {},
    models: {},
    collections: {},
    util: {},

    distribute_groups: null, // DistributeGroups
    accessible_accounts: null, // MobileAccounts
    _active_account_or_group: null,
    active_search_item_name: null, // The name of the active search account or group
    active_tab_id: null, // keep track of what page we're looking at across hierarchies

    initialize: function () {
        // not setting the current user_id on the distribute group because the restriction is applied in the generic
        this.distribute_groups = new MobileDistributeGroups();
        this.accessible_accounts = new MobileAccounts();
        this.accessible_accounts.paginator.set('order_by', 'name'); // order_by name to NOT use GPS.  This loads faster

        // We need everything from the cache in order to find owned locations in
        // get_owned_accounts_for_active_user(). This is admittedly janky, but works for now. @jira:MOBILE-655
        this.accessible_accounts.paginator.set('limit', this.accessible_accounts.cache_fetch_limit);
    },

    /**
     *
     * Receives an account or group, sets the current active group or account
     *
     * @param model - Either Account or DistributeGroup
     */
    set_active_account_or_group: function (model) {
        this._active_account_or_group = model;
    },

    get_active_account_or_group: function () {
        if (!this._active_account_or_group) {
            this._active_account_or_group = this.distribute_groups.get_root_group();
        }

        return this._active_account_or_group;
        // can't use the get_hierarchy(true, cache) cache because it won't update based on our resetting of the current
    },

    get_active_account: function () {
        var model = this.get_active_account_or_group();
        if (this.is_account(model)) {
            return model;
        }

        return null;
    },

    get_active_group: function () {
        var model = this.get_active_account_or_group();
        if (this.is_group(model)) {
            return model;
        }

        return null;
    },

    is_account: function (model) {
        model = model || this.get_active_account_or_group();
        return model instanceof Account;
    },

    is_group: function (model) {
        model = model || this.get_active_account_or_group();
        return model instanceof DistributeGroup;
    },

    /**
     * Is the user only associated with a single leaf node
     *
     * Case1: Single group, is a leaf
     * Case2: 2 groups, My Teams  and Leaf
     *
     * @returns {boolean}
     */
    user_only_in_leaf: function () {
        if (this.distribute_groups.length == 1 && this.distribute_groups.findWhere({ is_leaf: true })) {
            return true;
        }

        return (
            this.distribute_groups.length == 2 &&
            this.distribute_groups.findWhere({ is_my_teams: true }) &&
            this.distribute_groups.findWhere({ is_leaf: true })
        );
    },

    /**
     * This is a view type for our users where they should only see the summary page of a location, no teams
     *
     * Needs to be:
     *          - the owner of just one account
     *          - only be in one leaf node group (potentially under my teams?)
     *          - a submitter
     *
     * @returns {boolean}
     */
    is_single_account_owner: function () {
        var owned_accounts = this.accessible_accounts.get_owned_accounts_for_active_user();
        return $f.active_user.is_submitter() && this.user_only_in_leaf() && owned_accounts.length == 1;
    },

    /**
     * This is the same logic as above but for the case where they are the owner of N accounts where we show
     * Just those accounts in the team tab to allow for navigation
     */
    is_multi_account_owner: function () {
        var owned_accounts = this.accessible_accounts.get_owned_accounts_for_active_user();
        return $f.active_user.is_submitter() && this.user_only_in_leaf() && owned_accounts.length > 1;
    }
};

export default dashboard;
